<template>
    <div class="content-box">
      <div class="box-heading">
        <h3>Participants</h3>
      </div>
      <div class="box-content">
        <ul>
          <li v-for="person in instanceData.names" :key="person.id">
            <div class="list-item">
              <span class="person-name">{{ person.name }}</span>
              <span class="status-container">
                <span v-if="!isConnected(person.id)" class="state disconnected">Disconnected</span>
                <span v-if="isCaughtUp(person.id)" class="state done">Caught up</span>
                <span v-else class="state progress">{{ lockedCount(person.id) }}/{{ totalThings }}</span>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
import { hasSavedThing, lockedCountForUser } from "@/utils/votes";

export default {
  props: {
    instanceData: {
      type: Object,
      default: null
    },
  },
  computed: {
    totalThings() {
      return this.instanceData?.things?.length || 0;
    },
    isConnected() {
      return (userId) => {
        const connected = this.instanceData.connectedParticipants || [];
        return connected.includes(userId);
      };
    },
    lockedCount() {
      return (userId) => lockedCountForUser(this.instanceData.rankings, userId, this.instanceData.things);
    },
    isCaughtUp() {
      return (userId) => {
        if (!this.totalThings) return false;
        return (this.instanceData.things || []).every((thing) =>
          hasSavedThing(this.instanceData.rankings, userId, thing.id)
        );
      };
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
  margin-top: 10px;
}

.list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  border-bottom: 1px solid #ddd;
  padding: 10px 0;
}

.person-name {
  text-align: left;
}

li:last-child .list-item {
  border-bottom: none;
}

.status-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.state {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.state.done {
  background-color: #27ae60;
  color: white;
}

.state.progress {
  background-color: #ecf0f1;
  color: #333;
}

.state.disconnected {
  background-color: #e74c3c;
  color: white;
}
</style>
